(function () {
  var btn = document.querySelector('[data-scroll-to-top]');
  if (!btn) return;
  btn.hidden = false;
  var ticking = false;
  function update() {
    btn.classList.toggle('is-visible', window.scrollY > 400);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  update();
})();
